import * as _ from 'underscore';

import ACTIONS from '../actions';

const blockTree = (state = {}, action) => {
    function addExerciseKeys(block) {
        const exerciseKeys = [];
        for (let i = 0; i < block.exercises.length; i++) {
            exerciseKeys.push(block.exercises[i]);
        }
        block.exerciseKeys = exerciseKeys;
        return block;
    }

    let newState = { ...state };
    let block = null;
    let exercises = [];
    let exerciseKeys = [];

    switch (action.type) {
        case ACTIONS.CALENDAR_ADD_PROGRAM_WORKOUTS:
            if (action.payload.entities.sets) {
                Object.keys(action.payload.entities.sets).forEach(key => {
                    block = addExerciseKeys(action.payload.entities.sets[key]);
                    newState[key] = {
                        ...block,
                        key: parseInt(key, 10)
                    };
                });
            }
            return newState;
        case ACTIONS.DAYS_RELOAD:
            newState = { ...action.payload.entities.sets };
            Object.keys(newState).forEach(key => {
                newState[key].key = newState[key].id;
                newState[key] = addExerciseKeys(newState[key]);
            });

            return {
                ...state,
                ...newState
            };
        case ACTIONS.DAYS_CLEAR:
            return {};
        case ACTIONS.EXERCISE_UPDATE:
        case ACTIONS.BLOCK_ADD:
            newState = {
                ...state,
                [action.block.key]: action.block
            };
            for (let i = 0; i < action.session.setKeys.length; i++) {
                const order = i + 1;
                if (
                    newState[action.session.setKeys[i]] &&
                    newState[action.session.setKeys[i]].order !== order
                ) {
                    newState[action.session.setKeys[i]] = {
                        ...newState[action.session.setKeys[i]],
                        order
                    };
                }
            }
            return newState;
        case ACTIONS.BLOCK_DELETE:
            var order = 1;
            var sessionData = action.session.data;
            for (let i = 0; i < sessionData.setKeys.length; i++) {
                if (newState[sessionData.setKeys[i]].key !== action.block.key) {
                    newState[sessionData.setKeys[i]] = {
                        ...newState[sessionData.setKeys[i]],
                        order
                    };
                    order++;
                } else {
                    // newState was a copy of the old state, so it has the
                    // deleted block key in it. Clean it up!
                    // TODO: Add this delete back in after verifying all other
                    // reducers remove their references to this block.
                    // delete newState[action.block.key];
                }
            }
            return newState;
        case ACTIONS.BLOCK_ADD_EXERCISE:
            block = state[action.block.key];
            if (action.position === 0) {
                exercises = [action.exercise.id, ...block.exercises];
                exerciseKeys = [action.exercise.id, ...block.exercises];
            } else {
                exercises = [...block.exercises, action.exercise.id];
                exerciseKeys = [...block.exercises, action.exercise.id];
            }
            return {
                ...state,
                [action.block.key]: {
                    ...block,
                    editing: false,
                    exercises,
                    exerciseKeys
                }
            };
        case ACTIONS.SET_EXERCISE_DELETE:
            block = {
                ...state[action.block.key]
            };
            for (let i = 0; i < block.exerciseKeys.length; i++) {
                if (block.exerciseKeys[i] !== action.setExercise.key) {
                    exerciseKeys.push(block.exerciseKeys[i]);
                }
            }
            block.exercises = exerciseKeys;
            block.exerciseKeys = exerciseKeys;
            return {
                ...state,
                [action.block.key]: block
            };
        case ACTIONS.BLOCK_UPDATE:
            return {
                ...state,
                [action.block.key]: {
                    ...state[action.block.key],
                    ...action.block
                }
            };
        case ACTIONS.BLOCK_UPDATE_ID:
            newState = {
                ...state,
                [action.block.key]: {
                    ...state[action.block.key],
                    id: action.block.id
                }
            };
            return newState;
        case ACTIONS.SESSION_UPDATE:
            for (let i = 0; i < action.session.setKeys.length; i++) {
                const order = i + 1;
                if (newState[action.session.setKeys[i]].order !== order) {
                    newState[action.session.setKeys[i]].order = order;
                }
            }
            return newState;
        case ACTIONS.SESSION_COPY:
            _.map(action.session.sets, set => {
                const orderedExercises = _.sortBy(set.exercises, 'order');
                set.exerciseKeys = _.pluck(orderedExercises, 'id');
                set.key = set.id;
                newState = {
                    ...newState,
                    [set.id]: set
                };
            });
            return newState;
        case ACTIONS.BLOCK_SYNC_ORDER:
            for (let i = 0; i < action.session.setKeys.length; i++) {
                const order = i + 1;
                newState[action.session.setKeys[i]] = {
                    ...newState[action.session.setKeys[i]],
                    order
                };
            }
            return newState;
        default:
            if (
                action.payload &&
                action.payload.entities &&
                action.payload.entities.sets
            ) {
                return { ...action.payload.entities.sets, ...state };
            }
            return state;
    }
};

export default blockTree;
